/* es5-ext/number/is-nan/shim.js */ function _(require, module, exports) {
    module.exports = function (value) {
        // eslint-disable-next-line no-self-compare
        return value !== value;
    };
}
